import { ReportListItemData } from './report-base';

export class CreditCardDeclinedReportData extends ReportListItemData {
  usercardID: number;
  maskedccnum: string;
  cardtype: string;
  expdate: string;
  dateDeclined: Date;
  amountDeclined: number;
  declinedReason: string;
  usercarddeclinedID: number;
}

export class CCDeclinedReport {
  totalNumberOfDeclinedCard: number;
  totalDeclinedAmount: number;
  list: CreditCardDeclinedReportData[];

  constructor(data: any = {}) {
    this.totalNumberOfDeclinedCard = +data.totalNumberOfDeclinedCard;
    this.totalDeclinedAmount = +data.totalDeclinedAmount;
    this.list = data.ccDeclinedReportUserList ? data.ccDeclinedReportUserList.map(l => new CreditCardDeclinedReportData(l)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/declined-report.ts